'use client';

/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 */

/* eslint-disable */

// @ts-ignore - ignore potential type issues as the project is importing itself
import * as clientComponents from "@siemens/ix";
import { type BorderlessChangedEvent, type CustomCloseEvent, type CustomLabelChangeEvent, type DateChangeEvent, type DateInputValidityState, type DateRangeChangeEvent, type DateTimeDateChangeEvent, type DateTimeSelectEvent, type ExpandedChangedEvent, type FilterState, type InputState, type IxApplicationHeaderCustomEvent, type IxBlindCustomEvent, type IxBreadcrumbCustomEvent, type IxCardListCustomEvent, type IxCategoryFilterCustomEvent, type IxCheckboxCustomEvent, type IxChipCustomEvent, type IxContentHeaderCustomEvent, type IxDateDropdownCustomEvent, type IxDateInputCustomEvent, type IxDatePickerCustomEvent, type IxDatetimePickerCustomEvent, type IxDrawerCustomEvent, type IxDropdownCustomEvent, type IxEmptyStateCustomEvent, type IxEventListItemCustomEvent, type IxExpandingSearchCustomEvent, type IxFilterChipCustomEvent, type IxFlipTileCustomEvent, type IxGroupCustomEvent, type IxGroupItemCustomEvent, type IxIconToggleButtonCustomEvent, type IxInputCustomEvent, type IxMenuAboutCustomEvent, type IxMenuAboutItemCustomEvent, type IxMenuAboutNewsCustomEvent, type IxMenuAvatarCustomEvent, type IxMenuAvatarItemCustomEvent, type IxMenuCustomEvent, type IxMenuSettingsCustomEvent, type IxMenuSettingsItemCustomEvent, type IxMessageBarCustomEvent, type IxModalCustomEvent, type IxModalHeaderCustomEvent, type IxNumberInputCustomEvent, type IxPaginationCustomEvent, type IxPaneCustomEvent, type IxRadioCustomEvent, type IxRadioGroupCustomEvent, type IxSelectCustomEvent, type IxSelectItemCustomEvent, type IxSliderCustomEvent, type IxSplitButtonCustomEvent, type IxTabItemCustomEvent, type IxTabsCustomEvent, type IxTextareaCustomEvent, type IxTimeInputCustomEvent, type IxTimePickerCustomEvent, type IxToastCustomEvent, type IxToggleButtonCustomEvent, type IxToggleCustomEvent, type IxUploadCustomEvent, type IxWorkflowStepsCustomEvent, type TabClickDetail, type TimeInputValidityState, type VariantChangedEvent } from "@siemens/ix";
import { IxActionCard as IxActionCardElement } from "@siemens/ix/components/ix-action-card.js";
import { IxApplicationHeader as IxApplicationHeaderElement } from "@siemens/ix/components/ix-application-header.js";
import { IxApplication as IxApplicationElement } from "@siemens/ix/components/ix-application.js";
import { IxAvatar as IxAvatarElement } from "@siemens/ix/components/ix-avatar.js";
import { IxBlind as IxBlindElement } from "@siemens/ix/components/ix-blind.js";
import { IxBreadcrumbItem as IxBreadcrumbItemElement } from "@siemens/ix/components/ix-breadcrumb-item.js";
import { IxBreadcrumb as IxBreadcrumbElement } from "@siemens/ix/components/ix-breadcrumb.js";
import { IxButton as IxButtonElement } from "@siemens/ix/components/ix-button.js";
import { IxCardAccordion as IxCardAccordionElement } from "@siemens/ix/components/ix-card-accordion.js";
import { IxCardContent as IxCardContentElement } from "@siemens/ix/components/ix-card-content.js";
import { IxCardList as IxCardListElement } from "@siemens/ix/components/ix-card-list.js";
import { IxCardTitle as IxCardTitleElement } from "@siemens/ix/components/ix-card-title.js";
import { IxCard as IxCardElement } from "@siemens/ix/components/ix-card.js";
import { IxCategoryFilter as IxCategoryFilterElement } from "@siemens/ix/components/ix-category-filter.js";
import { IxCheckboxGroup as IxCheckboxGroupElement } from "@siemens/ix/components/ix-checkbox-group.js";
import { IxCheckbox as IxCheckboxElement } from "@siemens/ix/components/ix-checkbox.js";
import { IxChip as IxChipElement } from "@siemens/ix/components/ix-chip.js";
import { IxCol as IxColElement } from "@siemens/ix/components/ix-col.js";
import { IxContentHeader as IxContentHeaderElement } from "@siemens/ix/components/ix-content-header.js";
import { IxContent as IxContentElement } from "@siemens/ix/components/ix-content.js";
import { IxCustomField as IxCustomFieldElement } from "@siemens/ix/components/ix-custom-field.js";
import { IxDateDropdown as IxDateDropdownElement } from "@siemens/ix/components/ix-date-dropdown.js";
import { IxDateInput as IxDateInputElement } from "@siemens/ix/components/ix-date-input.js";
import { IxDatePicker as IxDatePickerElement } from "@siemens/ix/components/ix-date-picker.js";
import { IxDatetimePicker as IxDatetimePickerElement } from "@siemens/ix/components/ix-datetime-picker.js";
import { IxDivider as IxDividerElement } from "@siemens/ix/components/ix-divider.js";
import { IxDrawer as IxDrawerElement } from "@siemens/ix/components/ix-drawer.js";
import { IxDropdownButton as IxDropdownButtonElement } from "@siemens/ix/components/ix-dropdown-button.js";
import { IxDropdownHeader as IxDropdownHeaderElement } from "@siemens/ix/components/ix-dropdown-header.js";
import { IxDropdownItem as IxDropdownItemElement } from "@siemens/ix/components/ix-dropdown-item.js";
import { IxDropdownQuickActions as IxDropdownQuickActionsElement } from "@siemens/ix/components/ix-dropdown-quick-actions.js";
import { IxDropdown as IxDropdownElement } from "@siemens/ix/components/ix-dropdown.js";
import { IxEmptyState as IxEmptyStateElement } from "@siemens/ix/components/ix-empty-state.js";
import { IxEventListItem as IxEventListItemElement } from "@siemens/ix/components/ix-event-list-item.js";
import { IxEventList as IxEventListElement } from "@siemens/ix/components/ix-event-list.js";
import { IxExpandingSearch as IxExpandingSearchElement } from "@siemens/ix/components/ix-expanding-search.js";
import { IxFieldLabel as IxFieldLabelElement } from "@siemens/ix/components/ix-field-label.js";
import { IxFilterChip as IxFilterChipElement } from "@siemens/ix/components/ix-filter-chip.js";
import { IxFlipTileContent as IxFlipTileContentElement } from "@siemens/ix/components/ix-flip-tile-content.js";
import { IxFlipTile as IxFlipTileElement } from "@siemens/ix/components/ix-flip-tile.js";
import { IxGroupContextMenu as IxGroupContextMenuElement } from "@siemens/ix/components/ix-group-context-menu.js";
import { IxGroupItem as IxGroupItemElement } from "@siemens/ix/components/ix-group-item.js";
import { IxGroup as IxGroupElement } from "@siemens/ix/components/ix-group.js";
import { IxHelperText as IxHelperTextElement } from "@siemens/ix/components/ix-helper-text.js";
import { IxIconButton as IxIconButtonElement } from "@siemens/ix/components/ix-icon-button.js";
import { IxIconToggleButton as IxIconToggleButtonElement } from "@siemens/ix/components/ix-icon-toggle-button.js";
import { IxInputGroup as IxInputGroupElement } from "@siemens/ix/components/ix-input-group.js";
import { IxInput as IxInputElement } from "@siemens/ix/components/ix-input.js";
import { IxKeyValueList as IxKeyValueListElement } from "@siemens/ix/components/ix-key-value-list.js";
import { IxKeyValue as IxKeyValueElement } from "@siemens/ix/components/ix-key-value.js";
import { IxKpi as IxKpiElement } from "@siemens/ix/components/ix-kpi.js";
import { IxLayoutAuto as IxLayoutAutoElement } from "@siemens/ix/components/ix-layout-auto.js";
import { IxLayoutGrid as IxLayoutGridElement } from "@siemens/ix/components/ix-layout-grid.js";
import { IxLinkButton as IxLinkButtonElement } from "@siemens/ix/components/ix-link-button.js";
import { IxMenuAboutItem as IxMenuAboutItemElement } from "@siemens/ix/components/ix-menu-about-item.js";
import { IxMenuAboutNews as IxMenuAboutNewsElement } from "@siemens/ix/components/ix-menu-about-news.js";
import { IxMenuAbout as IxMenuAboutElement } from "@siemens/ix/components/ix-menu-about.js";
import { IxMenuAvatarItem as IxMenuAvatarItemElement } from "@siemens/ix/components/ix-menu-avatar-item.js";
import { IxMenuAvatar as IxMenuAvatarElement } from "@siemens/ix/components/ix-menu-avatar.js";
import { IxMenuCategory as IxMenuCategoryElement } from "@siemens/ix/components/ix-menu-category.js";
import { IxMenuItem as IxMenuItemElement } from "@siemens/ix/components/ix-menu-item.js";
import { IxMenuSettingsItem as IxMenuSettingsItemElement } from "@siemens/ix/components/ix-menu-settings-item.js";
import { IxMenuSettings as IxMenuSettingsElement } from "@siemens/ix/components/ix-menu-settings.js";
import { IxMenu as IxMenuElement } from "@siemens/ix/components/ix-menu.js";
import { IxMessageBar as IxMessageBarElement } from "@siemens/ix/components/ix-message-bar.js";
import { IxModalContent as IxModalContentElement } from "@siemens/ix/components/ix-modal-content.js";
import { IxModalFooter as IxModalFooterElement } from "@siemens/ix/components/ix-modal-footer.js";
import { IxModalHeader as IxModalHeaderElement } from "@siemens/ix/components/ix-modal-header.js";
import { IxModal as IxModalElement } from "@siemens/ix/components/ix-modal.js";
import { IxNumberInput as IxNumberInputElement } from "@siemens/ix/components/ix-number-input.js";
import { IxPagination as IxPaginationElement } from "@siemens/ix/components/ix-pagination.js";
import { IxPaneLayout as IxPaneLayoutElement } from "@siemens/ix/components/ix-pane-layout.js";
import { IxPane as IxPaneElement } from "@siemens/ix/components/ix-pane.js";
import { IxPill as IxPillElement } from "@siemens/ix/components/ix-pill.js";
import { IxProgressIndicator as IxProgressIndicatorElement } from "@siemens/ix/components/ix-progress-indicator.js";
import { IxPushCard as IxPushCardElement } from "@siemens/ix/components/ix-push-card.js";
import { IxRadioGroup as IxRadioGroupElement } from "@siemens/ix/components/ix-radio-group.js";
import { IxRadio as IxRadioElement } from "@siemens/ix/components/ix-radio.js";
import { IxRow as IxRowElement } from "@siemens/ix/components/ix-row.js";
import { IxSelectItem as IxSelectItemElement } from "@siemens/ix/components/ix-select-item.js";
import { IxSelect as IxSelectElement } from "@siemens/ix/components/ix-select.js";
import { IxSlider as IxSliderElement } from "@siemens/ix/components/ix-slider.js";
import { IxSpinner as IxSpinnerElement } from "@siemens/ix/components/ix-spinner.js";
import { IxSplitButton as IxSplitButtonElement } from "@siemens/ix/components/ix-split-button.js";
import { IxTabItem as IxTabItemElement } from "@siemens/ix/components/ix-tab-item.js";
import { IxTabs as IxTabsElement } from "@siemens/ix/components/ix-tabs.js";
import { IxTextarea as IxTextareaElement } from "@siemens/ix/components/ix-textarea.js";
import { IxTile as IxTileElement } from "@siemens/ix/components/ix-tile.js";
import { IxTimeInput as IxTimeInputElement } from "@siemens/ix/components/ix-time-input.js";
import { IxTimePicker as IxTimePickerElement } from "@siemens/ix/components/ix-time-picker.js";
import { IxToastContainer as IxToastContainerElement } from "@siemens/ix/components/ix-toast-container.js";
import { IxToast as IxToastElement } from "@siemens/ix/components/ix-toast.js";
import { IxToggleButton as IxToggleButtonElement } from "@siemens/ix/components/ix-toggle-button.js";
import { IxToggle as IxToggleElement } from "@siemens/ix/components/ix-toggle.js";
import { IxTooltip as IxTooltipElement } from "@siemens/ix/components/ix-tooltip.js";
import { IxTypography as IxTypographyElement } from "@siemens/ix/components/ix-typography.js";
import { IxUpload as IxUploadElement } from "@siemens/ix/components/ix-upload.js";
import { IxValidationTooltip as IxValidationTooltipElement } from "@siemens/ix/components/ix-validation-tooltip.js";
import { IxWorkflowStep as IxWorkflowStepElement } from "@siemens/ix/components/ix-workflow-step.js";
import { IxWorkflowSteps as IxWorkflowStepsElement } from "@siemens/ix/components/ix-workflow-steps.js";
import type { EventName, StencilReactComponent } from '@stencil/react-output-target/runtime';
import { createComponent, type HydrateModule, type ReactWebComponent, type SerializeShadowRootOptions } from '@stencil/react-output-target/ssr';

export const serializeShadowRoot: SerializeShadowRootOptions = { "scoped": [], "default": "declarative-shadow-dom" };

export type IxActionCardEvents = NonNullable<unknown>;

export const IxActionCard: StencilReactComponent<IxActionCardElement, IxActionCardEvents> = /*@__PURE__*/ createComponent<IxActionCardElement, IxActionCardEvents>({
    tagName: 'ix-action-card',
    properties: {
        variant: 'variant',
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        heading: 'heading',
        subheading: 'subheading',
        selected: 'selected',
        ariaLabelCard: 'aria-label-card',
        passive: 'passive'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxActionCard as ReactWebComponent<IxActionCardElement, IxActionCardEvents>,
    serializeShadowRoot
});

export type IxApplicationEvents = NonNullable<unknown>;

export const IxApplication: StencilReactComponent<IxApplicationElement, IxApplicationEvents> = /*@__PURE__*/ createComponent<IxApplicationElement, IxApplicationEvents>({
    tagName: 'ix-application',
    properties: {
        theme: 'theme',
        themeSystemAppearance: 'theme-system-appearance',
        forceBreakpoint: 'force-breakpoint'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxApplication as ReactWebComponent<IxApplicationElement, IxApplicationEvents>,
    serializeShadowRoot
});

export type IxApplicationHeaderEvents = {
    onMenuToggle: EventName<IxApplicationHeaderCustomEvent<boolean>>,
    onOpenAppSwitch: EventName<IxApplicationHeaderCustomEvent<void>>
};

export const IxApplicationHeader: StencilReactComponent<IxApplicationHeaderElement, IxApplicationHeaderEvents> = /*@__PURE__*/ createComponent<IxApplicationHeaderElement, IxApplicationHeaderEvents>({
    tagName: 'ix-application-header',
    properties: {
        name: 'name',
        nameSuffix: 'name-suffix',
        companyLogo: 'company-logo',
        companyLogoAlt: 'company-logo-alt',
        appIcon: 'app-icon',
        appIconAlt: 'app-icon-alt',
        appIconOutline: 'app-icon-outline',
        hideBottomBorder: 'hide-bottom-border',
        showMenu: 'show-menu',
        ariaLabelMenuExpandIconButton: 'aria-label-menu-expand-icon-button',
        ariaLabelAppSwitchIconButton: 'aria-label-app-switch-icon-button',
        ariaLabelMoreMenuIconButton: 'aria-label-more-menu-icon-button',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxApplicationHeader as ReactWebComponent<IxApplicationHeaderElement, IxApplicationHeaderEvents>,
    serializeShadowRoot
});

export type IxAvatarEvents = NonNullable<unknown>;

export const IxAvatar: StencilReactComponent<IxAvatarElement, IxAvatarEvents> = /*@__PURE__*/ createComponent<IxAvatarElement, IxAvatarEvents>({
    tagName: 'ix-avatar',
    properties: {
        a11yLabel: 'a11y-label',
        image: 'image',
        initials: 'initials',
        username: 'username',
        extra: 'extra',
        tooltipText: 'tooltip-text',
        ariaLabelTooltip: 'aria-label-tooltip'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxAvatar as ReactWebComponent<IxAvatarElement, IxAvatarEvents>,
    serializeShadowRoot
});

export type IxBlindEvents = { onCollapsedChange: EventName<IxBlindCustomEvent<boolean>> };

export const IxBlind: StencilReactComponent<IxBlindElement, IxBlindEvents> = /*@__PURE__*/ createComponent<IxBlindElement, IxBlindEvents>({
    tagName: 'ix-blind',
    properties: {
        collapsed: 'collapsed',
        label: 'label',
        sublabel: 'sublabel',
        icon: 'icon',
        variant: 'variant'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxBlind as ReactWebComponent<IxBlindElement, IxBlindEvents>,
    serializeShadowRoot
});

export type IxBreadcrumbEvents = {
    onItemClick: EventName<IxBreadcrumbCustomEvent<string>>,
    onNextClick: EventName<IxBreadcrumbCustomEvent<{ event: UIEvent; item: string }>>
};

export const IxBreadcrumb: StencilReactComponent<IxBreadcrumbElement, IxBreadcrumbEvents> = /*@__PURE__*/ createComponent<IxBreadcrumbElement, IxBreadcrumbEvents>({
    tagName: 'ix-breadcrumb',
    properties: {
        visibleItemCount: 'visible-item-count',
        subtle: 'subtle',
        ariaLabelPreviousButton: 'aria-label-previous-button',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxBreadcrumb as ReactWebComponent<IxBreadcrumbElement, IxBreadcrumbEvents>,
    serializeShadowRoot
});

export type IxBreadcrumbItemEvents = NonNullable<unknown>;

export const IxBreadcrumbItem: StencilReactComponent<IxBreadcrumbItemElement, IxBreadcrumbItemEvents> = /*@__PURE__*/ createComponent<IxBreadcrumbItemElement, IxBreadcrumbItemEvents>({
    tagName: 'ix-breadcrumb-item',
    properties: {
        ariaLabelButton: 'aria-label-button',
        label: 'label',
        icon: 'icon',
        href: 'href',
        target: 'target',
        rel: 'rel',
        subtle: 'subtle',
        invisible: 'invisible',
        hideChevron: 'hide-chevron',
        isDropdownTrigger: 'is-dropdown-trigger'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxBreadcrumbItem as ReactWebComponent<IxBreadcrumbItemElement, IxBreadcrumbItemEvents>,
    serializeShadowRoot
});

export type IxButtonEvents = NonNullable<unknown>;

export const IxButton: StencilReactComponent<IxButtonElement, IxButtonEvents> = /*@__PURE__*/ createComponent<IxButtonElement, IxButtonEvents>({
    tagName: 'ix-button',
    properties: {
        ariaLabelButton: 'aria-label-button',
        variant: 'variant',
        disabled: 'disabled',
        type: 'type',
        loading: 'loading',
        form: 'form',
        icon: 'icon',
        iconRight: 'icon-right',
        alignment: 'alignment',
        iconSize: 'icon-size',
        href: 'href',
        target: 'target',
        rel: 'rel'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxButton as ReactWebComponent<IxButtonElement, IxButtonEvents>,
    serializeShadowRoot
});

export type IxCardEvents = NonNullable<unknown>;

export const IxCard: StencilReactComponent<IxCardElement, IxCardEvents> = /*@__PURE__*/ createComponent<IxCardElement, IxCardEvents>({
    tagName: 'ix-card',
    properties: {
        variant: 'variant',
        selected: 'selected',
        passive: 'passive'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCard as ReactWebComponent<IxCardElement, IxCardEvents>,
    serializeShadowRoot
});

export type IxCardAccordionEvents = NonNullable<unknown>;

export const IxCardAccordion: StencilReactComponent<IxCardAccordionElement, IxCardAccordionEvents> = /*@__PURE__*/ createComponent<IxCardAccordionElement, IxCardAccordionEvents>({
    tagName: 'ix-card-accordion',
    properties: {
        ariaLabelExpandButton: 'aria-label-expand-button',
        collapse: 'collapse',
        variant: 'variant'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCardAccordion as ReactWebComponent<IxCardAccordionElement, IxCardAccordionEvents>,
    serializeShadowRoot
});

export type IxCardContentEvents = NonNullable<unknown>;

export const IxCardContent: StencilReactComponent<IxCardContentElement, IxCardContentEvents> = /*@__PURE__*/ createComponent<IxCardContentElement, IxCardContentEvents>({
    tagName: 'ix-card-content',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCardContent as ReactWebComponent<IxCardContentElement, IxCardContentEvents>,
    serializeShadowRoot
});

export type IxCardListEvents = {
    onCollapseChanged: EventName<IxCardListCustomEvent<boolean>>,
    onShowAllClick: EventName<IxCardListCustomEvent<{ nativeEvent: MouseEvent; }>>,
    onShowMoreCardClick: EventName<IxCardListCustomEvent<{ nativeEvent: MouseEvent; }>>
};

export const IxCardList: StencilReactComponent<IxCardListElement, IxCardListEvents> = /*@__PURE__*/ createComponent<IxCardListElement, IxCardListEvents>({
    tagName: 'ix-card-list',
    properties: {
        ariaLabelExpandButton: 'aria-label-expand-button',
        label: 'label',
        collapse: 'collapse',
        listStyle: 'list-style',
        maxVisibleCards: 'max-visible-cards',
        showAllCount: 'show-all-count',
        suppressOverflowHandling: 'suppress-overflow-handling',
        hideShowAll: 'hide-show-all',
        i18nShowAll: 'i18n-show-all',
        i18nMoreCards: 'i18n-more-cards'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCardList as ReactWebComponent<IxCardListElement, IxCardListEvents>,
    serializeShadowRoot
});

export type IxCardTitleEvents = NonNullable<unknown>;

export const IxCardTitle: StencilReactComponent<IxCardTitleElement, IxCardTitleEvents> = /*@__PURE__*/ createComponent<IxCardTitleElement, IxCardTitleEvents>({
    tagName: 'ix-card-title',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCardTitle as ReactWebComponent<IxCardTitleElement, IxCardTitleEvents>,
    serializeShadowRoot
});

export type IxCategoryFilterEvents = {
    onCategoryChanged: EventName<IxCategoryFilterCustomEvent<string>>,
    onInputChanged: EventName<IxCategoryFilterCustomEvent<InputState>>,
    onFilterChanged: EventName<IxCategoryFilterCustomEvent<FilterState>>,
    onFilterCleared: EventName<IxCategoryFilterCustomEvent<void>>
};

export const IxCategoryFilter: StencilReactComponent<IxCategoryFilterElement, IxCategoryFilterEvents> = /*@__PURE__*/ createComponent<IxCategoryFilterElement, IxCategoryFilterEvents>({
    tagName: 'ix-category-filter',
    properties: {
        disabled: 'disabled',
        readonly: 'readonly',
        placeholder: 'placeholder',
        icon: 'icon',
        hideIcon: 'hide-icon',
        staticOperator: 'static-operator',
        uniqueCategories: 'unique-categories',
        labelCategories: 'label-categories',
        i18nPlainText: 'i18n-plain-text',
        ariaLabelResetButton: 'aria-label-reset-button',
        ariaLabelOperatorButton: 'aria-label-operator-button',
        ariaLabelFilterInput: 'aria-label-filter-input',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCategoryFilter as ReactWebComponent<IxCategoryFilterElement, IxCategoryFilterEvents>,
    serializeShadowRoot
});

export type IxCheckboxEvents = {
    onCheckedChange: EventName<IxCheckboxCustomEvent<boolean>>,
    onValueChange: EventName<IxCheckboxCustomEvent<string>>,
    onIxBlur: EventName<IxCheckboxCustomEvent<void>>
};

export const IxCheckbox: StencilReactComponent<IxCheckboxElement, IxCheckboxEvents> = /*@__PURE__*/ createComponent<IxCheckboxElement, IxCheckboxEvents>({
    tagName: 'ix-checkbox',
    properties: {
        name: 'name',
        value: 'value',
        label: 'label',
        checked: 'checked',
        disabled: 'disabled',
        indeterminate: 'indeterminate',
        required: 'required'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCheckbox as ReactWebComponent<IxCheckboxElement, IxCheckboxEvents>,
    serializeShadowRoot
});

export type IxCheckboxGroupEvents = NonNullable<unknown>;

export const IxCheckboxGroup: StencilReactComponent<IxCheckboxGroupElement, IxCheckboxGroupEvents> = /*@__PURE__*/ createComponent<IxCheckboxGroupElement, IxCheckboxGroupEvents>({
    tagName: 'ix-checkbox-group',
    properties: {
        helperText: 'helper-text',
        label: 'label',
        direction: 'direction',
        invalidText: 'invalid-text',
        infoText: 'info-text',
        validText: 'valid-text',
        warningText: 'warning-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        required: 'required'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCheckboxGroup as ReactWebComponent<IxCheckboxGroupElement, IxCheckboxGroupEvents>,
    serializeShadowRoot
});

export type IxChipEvents = { onCloseChip: EventName<IxChipCustomEvent<any>> };

export const IxChip: StencilReactComponent<IxChipElement, IxChipEvents> = /*@__PURE__*/ createComponent<IxChipElement, IxChipEvents>({
    tagName: 'ix-chip',
    properties: {
        variant: 'variant',
        inactive: 'inactive',
        closable: 'closable',
        icon: 'icon',
        background: 'background',
        chipColor: 'chip-color',
        outline: 'outline',
        tooltipText: 'tooltip-text',
        centerContent: 'center-content',
        ariaLabelCloseButton: 'aria-label-close-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxChip as ReactWebComponent<IxChipElement, IxChipEvents>,
    serializeShadowRoot
});

export type IxColEvents = NonNullable<unknown>;

export const IxCol: StencilReactComponent<IxColElement, IxColEvents> = /*@__PURE__*/ createComponent<IxColElement, IxColEvents>({
    tagName: 'ix-col',
    properties: {
        size: 'size',
        sizeSm: 'size-sm',
        sizeMd: 'size-md',
        sizeLg: 'size-lg'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCol as ReactWebComponent<IxColElement, IxColEvents>,
    serializeShadowRoot
});

export type IxContentEvents = NonNullable<unknown>;

export const IxContent: StencilReactComponent<IxContentElement, IxContentEvents> = /*@__PURE__*/ createComponent<IxContentElement, IxContentEvents>({
    tagName: 'ix-content',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxContent as ReactWebComponent<IxContentElement, IxContentEvents>,
    serializeShadowRoot
});

export type IxContentHeaderEvents = { onBackButtonClick: EventName<IxContentHeaderCustomEvent<void>> };

export const IxContentHeader: StencilReactComponent<IxContentHeaderElement, IxContentHeaderEvents> = /*@__PURE__*/ createComponent<IxContentHeaderElement, IxContentHeaderEvents>({
    tagName: 'ix-content-header',
    properties: {
        variant: 'variant',
        headerTitle: 'header-title',
        headerSubtitle: 'header-subtitle',
        hasBackButton: 'has-back-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxContentHeader as ReactWebComponent<IxContentHeaderElement, IxContentHeaderEvents>,
    serializeShadowRoot
});

export type IxCustomFieldEvents = NonNullable<unknown>;

export const IxCustomField: StencilReactComponent<IxCustomFieldElement, IxCustomFieldEvents> = /*@__PURE__*/ createComponent<IxCustomFieldElement, IxCustomFieldEvents>({
    tagName: 'ix-custom-field',
    properties: {
        required: 'required',
        label: 'label',
        helperText: 'helper-text',
        infoText: 'info-text',
        warningText: 'warning-text',
        invalidText: 'invalid-text',
        validText: 'valid-text',
        showTextAsTooltip: 'show-text-as-tooltip'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxCustomField as ReactWebComponent<IxCustomFieldElement, IxCustomFieldEvents>,
    serializeShadowRoot
});

export type IxDateDropdownEvents = { onDateRangeChange: EventName<IxDateDropdownCustomEvent<DateRangeChangeEvent>> };

export const IxDateDropdown: StencilReactComponent<IxDateDropdownElement, IxDateDropdownEvents> = /*@__PURE__*/ createComponent<IxDateDropdownElement, IxDateDropdownEvents>({
    tagName: 'ix-date-dropdown',
    properties: {
        disabled: 'disabled',
        format: 'format',
        singleSelection: 'single-selection',
        from: 'from',
        to: 'to',
        minDate: 'min-date',
        maxDate: 'max-date',
        dateRangeId: 'date-range-id',
        variant: 'variant',
        loading: 'loading',
        showWeekNumbers: 'show-week-numbers',
        ariaLabelDropdownButton: 'aria-label-dropdown-button',
        customRangeDisabled: 'custom-range-disabled',
        locale: 'locale',
        weekStartIndex: 'week-start-index',
        i18nCustomItem: 'i18n-custom-item',
        i18nDone: 'i18n-done',
        i18nNoRange: 'i18n-no-range',
        today: 'today',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDateDropdown as ReactWebComponent<IxDateDropdownElement, IxDateDropdownEvents>,
    serializeShadowRoot
});

export type IxDateInputEvents = {
    onValueChange: EventName<IxDateInputCustomEvent<string | undefined>>,
    onValidityStateChange: EventName<IxDateInputCustomEvent<DateInputValidityState>>,
    onIxChange: EventName<IxDateInputCustomEvent<string | undefined>>
};

export const IxDateInput: StencilReactComponent<IxDateInputElement, IxDateInputEvents> = /*@__PURE__*/ createComponent<IxDateInputElement, IxDateInputEvents>({
    tagName: 'ix-date-input',
    properties: {
        name: 'name',
        placeholder: 'placeholder',
        value: 'value',
        minDate: 'min-date',
        maxDate: 'max-date',
        locale: 'locale',
        format: 'format',
        required: 'required',
        helperText: 'helper-text',
        label: 'label',
        ariaLabelCalendarButton: 'aria-label-calendar-button',
        invalidText: 'invalid-text',
        readonly: 'readonly',
        disabled: 'disabled',
        infoText: 'info-text',
        warningText: 'warning-text',
        validText: 'valid-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        i18nErrorDateUnparsable: 'i18n-error-date-unparsable',
        showWeekNumbers: 'show-week-numbers',
        weekStartIndex: 'week-start-index',
        ariaLabelPreviousMonthButton: 'aria-label-previous-month-button',
        ariaLabelNextMonthButton: 'aria-label-next-month-button',
        suppressSubmitOnEnter: 'suppress-submit-on-enter',
        textAlignment: 'text-alignment',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDateInput as ReactWebComponent<IxDateInputElement, IxDateInputEvents>,
    serializeShadowRoot
});

export type IxDatePickerEvents = {
    onDateChange: EventName<IxDatePickerCustomEvent<DateChangeEvent>>,
    onDateRangeChange: EventName<IxDatePickerCustomEvent<DateChangeEvent>>,
    onDateSelect: EventName<IxDatePickerCustomEvent<DateChangeEvent>>
};

export const IxDatePicker: StencilReactComponent<IxDatePickerElement, IxDatePickerEvents> = /*@__PURE__*/ createComponent<IxDatePickerElement, IxDatePickerEvents>({
    tagName: 'ix-date-picker',
    properties: {
        format: 'format',
        singleSelection: 'single-selection',
        corners: 'corners',
        from: 'from',
        to: 'to',
        minDate: 'min-date',
        maxDate: 'max-date',
        i18nDone: 'i18n-done',
        ariaLabelPreviousMonthButton: 'aria-label-previous-month-button',
        ariaLabelNextMonthButton: 'aria-label-next-month-button',
        weekStartIndex: 'week-start-index',
        locale: 'locale',
        showWeekNumbers: 'show-week-numbers',
        embedded: 'embedded',
        today: 'today',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDatePicker as ReactWebComponent<IxDatePickerElement, IxDatePickerEvents>,
    serializeShadowRoot
});

export type IxDatetimePickerEvents = {
    onTimeChange: EventName<IxDatetimePickerCustomEvent<string>>,
    onDateChange: EventName<IxDatetimePickerCustomEvent<DateTimeDateChangeEvent>>,
    onDateSelect: EventName<IxDatetimePickerCustomEvent<DateTimeSelectEvent>>
};

export const IxDatetimePicker: StencilReactComponent<IxDatetimePickerElement, IxDatetimePickerEvents> = /*@__PURE__*/ createComponent<IxDatetimePickerElement, IxDatetimePickerEvents>({
    tagName: 'ix-datetime-picker',
    properties: {
        singleSelection: 'single-selection',
        minDate: 'min-date',
        maxDate: 'max-date',
        dateFormat: 'date-format',
        timeFormat: 'time-format',
        from: 'from',
        to: 'to',
        time: 'time',
        showTimeReference: 'show-time-reference',
        timeReference: 'time-reference',
        i18nDone: 'i18n-done',
        i18nTime: 'i18n-time',
        ariaLabelPreviousMonthButton: 'aria-label-previous-month-button',
        ariaLabelNextMonthButton: 'aria-label-next-month-button',
        weekStartIndex: 'week-start-index',
        locale: 'locale',
        showWeekNumbers: 'show-week-numbers'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDatetimePicker as ReactWebComponent<IxDatetimePickerElement, IxDatetimePickerEvents>,
    serializeShadowRoot
});

export type IxDividerEvents = NonNullable<unknown>;

export const IxDivider: StencilReactComponent<IxDividerElement, IxDividerEvents> = /*@__PURE__*/ createComponent<IxDividerElement, IxDividerEvents>({
    tagName: 'ix-divider',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDivider as ReactWebComponent<IxDividerElement, IxDividerEvents>,
    serializeShadowRoot
});

export type IxDrawerEvents = {
    onOpen: EventName<IxDrawerCustomEvent<any>>,
    onDrawerClose: EventName<IxDrawerCustomEvent<any>>
};

export const IxDrawer: StencilReactComponent<IxDrawerElement, IxDrawerEvents> = /*@__PURE__*/ createComponent<IxDrawerElement, IxDrawerEvents>({
    tagName: 'ix-drawer',
    properties: {
        show: 'show',
        closeOnClickOutside: 'close-on-click-outside',
        fullHeight: 'full-height',
        minWidth: 'min-width',
        maxWidth: 'max-width',
        width: 'width',
        ariaLabelCloseButton: 'aria-label-close-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDrawer as ReactWebComponent<IxDrawerElement, IxDrawerEvents>,
    serializeShadowRoot
});

export type IxDropdownEvents = { onShowChanged: EventName<IxDropdownCustomEvent<boolean>> };

export const IxDropdown: StencilReactComponent<IxDropdownElement, IxDropdownEvents> = /*@__PURE__*/ createComponent<IxDropdownElement, IxDropdownEvents>({
    tagName: 'ix-dropdown',
    properties: {
        suppressAutomaticPlacement: 'suppress-automatic-placement',
        show: 'show',
        trigger: 'trigger',
        anchor: 'anchor',
        closeBehavior: 'close-behavior',
        placement: 'placement',
        positioningStrategy: 'positioning-strategy',
        header: 'header',
        discoverAllSubmenus: 'discover-all-submenus',
        ignoreRelatedSubmenu: 'ignore-related-submenu',
        suppressOverflowBehavior: 'suppress-overflow-behavior',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDropdown as ReactWebComponent<IxDropdownElement, IxDropdownEvents>,
    serializeShadowRoot
});

export type IxDropdownButtonEvents = NonNullable<unknown>;

export const IxDropdownButton: StencilReactComponent<IxDropdownButtonElement, IxDropdownButtonEvents> = /*@__PURE__*/ createComponent<IxDropdownButtonElement, IxDropdownButtonEvents>({
    tagName: 'ix-dropdown-button',
    properties: {
        variant: 'variant',
        disabled: 'disabled',
        label: 'label',
        icon: 'icon',
        closeBehavior: 'close-behavior',
        placement: 'placement',
        ariaLabelDropdownButton: 'aria-label-dropdown-button',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDropdownButton as ReactWebComponent<IxDropdownButtonElement, IxDropdownButtonEvents>,
    serializeShadowRoot
});

export type IxDropdownHeaderEvents = NonNullable<unknown>;

export const IxDropdownHeader: StencilReactComponent<IxDropdownHeaderElement, IxDropdownHeaderEvents> = /*@__PURE__*/ createComponent<IxDropdownHeaderElement, IxDropdownHeaderEvents>({
    tagName: 'ix-dropdown-header',
    properties: { label: 'label' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDropdownHeader as ReactWebComponent<IxDropdownHeaderElement, IxDropdownHeaderEvents>,
    serializeShadowRoot
});

export type IxDropdownItemEvents = NonNullable<unknown>;

export const IxDropdownItem: StencilReactComponent<IxDropdownItemElement, IxDropdownItemEvents> = /*@__PURE__*/ createComponent<IxDropdownItemElement, IxDropdownItemEvents>({
    tagName: 'ix-dropdown-item',
    properties: {
        label: 'label',
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        ariaLabelButton: 'aria-label-button',
        hover: 'hover',
        disabled: 'disabled',
        checked: 'checked',
        isSubMenu: 'is-sub-menu',
        suppressChecked: 'suppress-checked'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDropdownItem as ReactWebComponent<IxDropdownItemElement, IxDropdownItemEvents>,
    serializeShadowRoot
});

export type IxDropdownQuickActionsEvents = NonNullable<unknown>;

export const IxDropdownQuickActions: StencilReactComponent<IxDropdownQuickActionsElement, IxDropdownQuickActionsEvents> = /*@__PURE__*/ createComponent<IxDropdownQuickActionsElement, IxDropdownQuickActionsEvents>({
    tagName: 'ix-dropdown-quick-actions',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxDropdownQuickActions as ReactWebComponent<IxDropdownQuickActionsElement, IxDropdownQuickActionsEvents>,
    serializeShadowRoot
});

export type IxEmptyStateEvents = { onActionClick: EventName<IxEmptyStateCustomEvent<void>> };

export const IxEmptyState: StencilReactComponent<IxEmptyStateElement, IxEmptyStateEvents> = /*@__PURE__*/ createComponent<IxEmptyStateElement, IxEmptyStateEvents>({
    tagName: 'ix-empty-state',
    properties: {
        layout: 'layout',
        icon: 'icon',
        header: 'header',
        subHeader: 'sub-header',
        action: 'action',
        ariaLabelEmptyStateIcon: 'aria-label-empty-state-icon'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxEmptyState as ReactWebComponent<IxEmptyStateElement, IxEmptyStateEvents>,
    serializeShadowRoot
});

export type IxEventListEvents = NonNullable<unknown>;

export const IxEventList: StencilReactComponent<IxEventListElement, IxEventListEvents> = /*@__PURE__*/ createComponent<IxEventListElement, IxEventListEvents>({
    tagName: 'ix-event-list',
    properties: {
        itemHeight: 'item-height',
        compact: 'compact',
        animated: 'animated',
        chevron: 'chevron'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxEventList as ReactWebComponent<IxEventListElement, IxEventListEvents>,
    serializeShadowRoot
});

export type IxEventListItemEvents = { onItemClick: EventName<IxEventListItemCustomEvent<any>> };

export const IxEventListItem: StencilReactComponent<IxEventListItemElement, IxEventListItemEvents> = /*@__PURE__*/ createComponent<IxEventListItemElement, IxEventListItemEvents>({
    tagName: 'ix-event-list-item',
    properties: {
        variant: 'variant',
        itemColor: 'item-color',
        selected: 'selected',
        disabled: 'disabled',
        chevron: 'chevron'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxEventListItem as ReactWebComponent<IxEventListItemElement, IxEventListItemEvents>,
    serializeShadowRoot
});

export type IxExpandingSearchEvents = { onValueChange: EventName<IxExpandingSearchCustomEvent<string>> };

export const IxExpandingSearch: StencilReactComponent<IxExpandingSearchElement, IxExpandingSearchEvents> = /*@__PURE__*/ createComponent<IxExpandingSearchElement, IxExpandingSearchEvents>({
    tagName: 'ix-expanding-search',
    properties: {
        icon: 'icon',
        placeholder: 'placeholder',
        value: 'value',
        fullWidth: 'full-width',
        variant: 'variant',
        ariaLabelSearchIconButton: 'aria-label-search-icon-button',
        ariaLabelClearIconButton: 'aria-label-clear-icon-button',
        ariaLabelSearchInput: 'aria-label-search-input'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxExpandingSearch as ReactWebComponent<IxExpandingSearchElement, IxExpandingSearchEvents>,
    serializeShadowRoot
});

export type IxFieldLabelEvents = NonNullable<unknown>;

export const IxFieldLabel: StencilReactComponent<IxFieldLabelElement, IxFieldLabelEvents> = /*@__PURE__*/ createComponent<IxFieldLabelElement, IxFieldLabelEvents>({
    tagName: 'ix-field-label',
    properties: {
        required: 'required',
        htmlFor: 'html-for',
        isInvalid: 'is-invalid'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxFieldLabel as ReactWebComponent<IxFieldLabelElement, IxFieldLabelEvents>,
    serializeShadowRoot
});

export type IxFilterChipEvents = { onCloseClick: EventName<IxFilterChipCustomEvent<void>> };

export const IxFilterChip: StencilReactComponent<IxFilterChipElement, IxFilterChipEvents> = /*@__PURE__*/ createComponent<IxFilterChipElement, IxFilterChipEvents>({
    tagName: 'ix-filter-chip',
    properties: {
        disabled: 'disabled',
        readonly: 'readonly',
        ariaLabelCloseIconButton: 'aria-label-close-icon-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxFilterChip as ReactWebComponent<IxFilterChipElement, IxFilterChipEvents>,
    serializeShadowRoot
});

export type IxFlipTileEvents = { onToggle: EventName<IxFlipTileCustomEvent<number>> };

export const IxFlipTile: StencilReactComponent<IxFlipTileElement, IxFlipTileEvents> = /*@__PURE__*/ createComponent<IxFlipTileElement, IxFlipTileEvents>({
    tagName: 'ix-flip-tile',
    properties: {
        variant: 'variant',
        height: 'height',
        width: 'width',
        index: 'index',
        ariaLabelEyeIconButton: 'aria-label-eye-icon-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxFlipTile as ReactWebComponent<IxFlipTileElement, IxFlipTileEvents>,
    serializeShadowRoot
});

export type IxFlipTileContentEvents = NonNullable<unknown>;

export const IxFlipTileContent: StencilReactComponent<IxFlipTileContentElement, IxFlipTileContentEvents> = /*@__PURE__*/ createComponent<IxFlipTileContentElement, IxFlipTileContentEvents>({
    tagName: 'ix-flip-tile-content',
    properties: { contentVisible: 'content-visible' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxFlipTileContent as ReactWebComponent<IxFlipTileContentElement, IxFlipTileContentEvents>,
    serializeShadowRoot
});

export type IxGroupEvents = {
    onSelectGroup: EventName<IxGroupCustomEvent<boolean>>,
    onSelectItem: EventName<IxGroupCustomEvent<number>>,
    onExpandedChanged: EventName<IxGroupCustomEvent<boolean>>
};

export const IxGroup: StencilReactComponent<IxGroupElement, IxGroupEvents> = /*@__PURE__*/ createComponent<IxGroupElement, IxGroupEvents>({
    tagName: 'ix-group',
    properties: {
        suppressHeaderSelection: 'suppress-header-selection',
        header: 'header',
        subHeader: 'sub-header',
        expanded: 'expanded',
        selected: 'selected',
        index: 'index',
        expandOnHeaderClick: 'expand-on-header-click'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxGroup as ReactWebComponent<IxGroupElement, IxGroupEvents>,
    serializeShadowRoot
});

export type IxGroupContextMenuEvents = NonNullable<unknown>;

export const IxGroupContextMenu: StencilReactComponent<IxGroupContextMenuElement, IxGroupContextMenuEvents> = /*@__PURE__*/ createComponent<IxGroupContextMenuElement, IxGroupContextMenuEvents>({
    tagName: 'ix-group-context-menu',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxGroupContextMenu as ReactWebComponent<IxGroupContextMenuElement, IxGroupContextMenuEvents>,
    serializeShadowRoot
});

export type IxGroupItemEvents = { onSelectedChanged: EventName<IxGroupItemCustomEvent<HTMLIxGroupItemElement>> };

export const IxGroupItem: StencilReactComponent<IxGroupItemElement, IxGroupItemEvents> = /*@__PURE__*/ createComponent<IxGroupItemElement, IxGroupItemEvents>({
    tagName: 'ix-group-item',
    properties: {
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        text: 'text',
        secondaryText: 'secondary-text',
        suppressSelection: 'suppress-selection',
        groupFooter: 'group-footer',
        selected: 'selected',
        disabled: 'disabled',
        index: 'index'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxGroupItem as ReactWebComponent<IxGroupItemElement, IxGroupItemEvents>,
    serializeShadowRoot
});

export type IxHelperTextEvents = NonNullable<unknown>;

export const IxHelperText: StencilReactComponent<IxHelperTextElement, IxHelperTextEvents> = /*@__PURE__*/ createComponent<IxHelperTextElement, IxHelperTextEvents>({
    tagName: 'ix-helper-text',
    properties: {
        htmlFor: 'html-for',
        helperText: 'helper-text',
        invalidText: 'invalid-text',
        validText: 'valid-text',
        infoText: 'info-text',
        warningText: 'warning-text'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxHelperText as ReactWebComponent<IxHelperTextElement, IxHelperTextEvents>,
    serializeShadowRoot
});

export type IxIconButtonEvents = NonNullable<unknown>;

export const IxIconButton: StencilReactComponent<IxIconButtonElement, IxIconButtonEvents> = /*@__PURE__*/ createComponent<IxIconButtonElement, IxIconButtonEvents>({
    tagName: 'ix-icon-button',
    properties: {
        a11yLabel: 'a11y-label',
        variant: 'variant',
        oval: 'oval',
        icon: 'icon',
        size: 'size',
        iconColor: 'icon-color',
        disabled: 'disabled',
        type: 'type',
        loading: 'loading'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxIconButton as ReactWebComponent<IxIconButtonElement, IxIconButtonEvents>,
    serializeShadowRoot
});

export type IxIconToggleButtonEvents = { onPressedChange: EventName<IxIconToggleButtonCustomEvent<boolean>> };

export const IxIconToggleButton: StencilReactComponent<IxIconToggleButtonElement, IxIconToggleButtonEvents> = /*@__PURE__*/ createComponent<IxIconToggleButtonElement, IxIconToggleButtonEvents>({
    tagName: 'ix-icon-toggle-button',
    properties: {
        variant: 'variant',
        outline: 'outline',
        ghost: 'ghost',
        icon: 'icon',
        oval: 'oval',
        pressed: 'pressed',
        size: 'size',
        disabled: 'disabled',
        loading: 'loading',
        ariaLabelIconButton: 'aria-label-icon-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxIconToggleButton as ReactWebComponent<IxIconToggleButtonElement, IxIconToggleButtonEvents>,
    serializeShadowRoot
});

export type IxInputEvents = {
    onValueChange: EventName<IxInputCustomEvent<string>>,
    onValidityStateChange: EventName<IxInputCustomEvent<ValidityState>>,
    onIxBlur: EventName<IxInputCustomEvent<void>>,
    onIxChange: EventName<IxInputCustomEvent<string>>
};

export const IxInput: StencilReactComponent<IxInputElement, IxInputEvents> = /*@__PURE__*/ createComponent<IxInputElement, IxInputEvents>({
    tagName: 'ix-input',
    properties: {
        type: 'type',
        name: 'name',
        placeholder: 'placeholder',
        value: 'value',
        required: 'required',
        disabled: 'disabled',
        readonly: 'readonly',
        helperText: 'helper-text',
        infoText: 'info-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        validText: 'valid-text',
        warningText: 'warning-text',
        label: 'label',
        invalidText: 'invalid-text',
        pattern: 'pattern',
        maxLength: 'max-length',
        minLength: 'min-length',
        allowedCharactersPattern: 'allowed-characters-pattern',
        suppressSubmitOnEnter: 'suppress-submit-on-enter',
        textAlignment: 'text-alignment'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxInput as ReactWebComponent<IxInputElement, IxInputEvents>,
    serializeShadowRoot
});

export type IxInputGroupEvents = NonNullable<unknown>;

export const IxInputGroup: StencilReactComponent<IxInputGroupElement, IxInputGroupEvents> = /*@__PURE__*/ createComponent<IxInputGroupElement, IxInputGroupEvents>({
    tagName: 'ix-input-group',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxInputGroup as ReactWebComponent<IxInputGroupElement, IxInputGroupEvents>,
    serializeShadowRoot
});

export type IxKeyValueEvents = NonNullable<unknown>;

export const IxKeyValue: StencilReactComponent<IxKeyValueElement, IxKeyValueEvents> = /*@__PURE__*/ createComponent<IxKeyValueElement, IxKeyValueEvents>({
    tagName: 'ix-key-value',
    properties: {
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        label: 'label',
        labelPosition: 'label-position',
        value: 'value'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxKeyValue as ReactWebComponent<IxKeyValueElement, IxKeyValueEvents>,
    serializeShadowRoot
});

export type IxKeyValueListEvents = NonNullable<unknown>;

export const IxKeyValueList: StencilReactComponent<IxKeyValueListElement, IxKeyValueListEvents> = /*@__PURE__*/ createComponent<IxKeyValueListElement, IxKeyValueListEvents>({
    tagName: 'ix-key-value-list',
    properties: { striped: 'striped' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxKeyValueList as ReactWebComponent<IxKeyValueListElement, IxKeyValueListEvents>,
    serializeShadowRoot
});

export type IxKpiEvents = NonNullable<unknown>;

export const IxKpi: StencilReactComponent<IxKpiElement, IxKpiEvents> = /*@__PURE__*/ createComponent<IxKpiElement, IxKpiEvents>({
    tagName: 'ix-kpi',
    properties: {
        label: 'label',
        ariaLabelAlarmIcon: 'aria-label-alarm-icon',
        ariaLabelWarningIcon: 'aria-label-warning-icon',
        value: 'value',
        unit: 'unit',
        state: 'state',
        orientation: 'orientation'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxKpi as ReactWebComponent<IxKpiElement, IxKpiEvents>,
    serializeShadowRoot
});

export type IxLayoutAutoEvents = NonNullable<unknown>;

export const IxLayoutAuto: StencilReactComponent<IxLayoutAutoElement, IxLayoutAutoEvents> = /*@__PURE__*/ createComponent<IxLayoutAutoElement, IxLayoutAutoEvents>({
    tagName: 'ix-layout-auto',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxLayoutAuto as ReactWebComponent<IxLayoutAutoElement, IxLayoutAutoEvents>,
    serializeShadowRoot
});

export type IxLayoutGridEvents = NonNullable<unknown>;

export const IxLayoutGrid: StencilReactComponent<IxLayoutGridElement, IxLayoutGridEvents> = /*@__PURE__*/ createComponent<IxLayoutGridElement, IxLayoutGridEvents>({
    tagName: 'ix-layout-grid',
    properties: {
        noMargin: 'no-margin',
        gap: 'gap',
        columns: 'columns'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxLayoutGrid as ReactWebComponent<IxLayoutGridElement, IxLayoutGridEvents>,
    serializeShadowRoot
});

export type IxLinkButtonEvents = NonNullable<unknown>;

export const IxLinkButton: StencilReactComponent<IxLinkButtonElement, IxLinkButtonEvents> = /*@__PURE__*/ createComponent<IxLinkButtonElement, IxLinkButtonEvents>({
    tagName: 'ix-link-button',
    properties: {
        disabled: 'disabled',
        url: 'url',
        target: 'target'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxLinkButton as ReactWebComponent<IxLinkButtonElement, IxLinkButtonEvents>,
    serializeShadowRoot
});

export type IxMenuEvents = {
    onExpandChange: EventName<IxMenuCustomEvent<boolean>>,
    onMapExpandChange: EventName<IxMenuCustomEvent<boolean>>,
    onOpenAppSwitch: EventName<IxMenuCustomEvent<void>>,
    onOpenSettings: EventName<IxMenuCustomEvent<void>>,
    onOpenAbout: EventName<IxMenuCustomEvent<void>>
};

export const IxMenu: StencilReactComponent<IxMenuElement, IxMenuEvents> = /*@__PURE__*/ createComponent<IxMenuElement, IxMenuEvents>({
    tagName: 'ix-menu',
    properties: {
        showSettings: 'show-settings',
        showAbout: 'show-about',
        enableToggleTheme: 'enable-toggle-theme',
        enableMapExpand: 'enable-map-expand',
        applicationName: 'application-name',
        applicationDescription: 'application-description',
        i18nExpandSidebar: 'i18n-expand-sidebar',
        expand: 'expand',
        startExpanded: 'start-expanded',
        pinned: 'pinned',
        i18nLegal: 'i18n-legal',
        i18nSettings: 'i18n-settings',
        i18nToggleTheme: 'i18n-toggle-theme',
        i18nExpand: 'i18n-expand',
        i18nCollapse: 'i18n-collapse'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenu as ReactWebComponent<IxMenuElement, IxMenuEvents>,
    serializeShadowRoot
});

export type IxMenuAboutEvents = {
    onTabChange: EventName<IxMenuAboutCustomEvent<string>>,
    onClose: EventName<IxMenuAboutCustomEvent<CustomCloseEvent>>
};

export const IxMenuAbout: StencilReactComponent<IxMenuAboutElement, IxMenuAboutEvents> = /*@__PURE__*/ createComponent<IxMenuAboutElement, IxMenuAboutEvents>({
    tagName: 'ix-menu-about',
    properties: {
        activeTabLabel: 'active-tab-label',
        label: 'label',
        ariaLabelCloseButton: 'aria-label-close-button',
        show: 'show'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuAbout as ReactWebComponent<IxMenuAboutElement, IxMenuAboutEvents>,
    serializeShadowRoot
});

export type IxMenuAboutItemEvents = { onLabelChange: EventName<IxMenuAboutItemCustomEvent<CustomLabelChangeEvent>> };

export const IxMenuAboutItem: StencilReactComponent<IxMenuAboutItemElement, IxMenuAboutItemEvents> = /*@__PURE__*/ createComponent<IxMenuAboutItemElement, IxMenuAboutItemEvents>({
    tagName: 'ix-menu-about-item',
    properties: { label: 'label' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuAboutItem as ReactWebComponent<IxMenuAboutItemElement, IxMenuAboutItemEvents>,
    serializeShadowRoot
});

export type IxMenuAboutNewsEvents = {
    onShowMore: EventName<IxMenuAboutNewsCustomEvent<MouseEvent>>,
    onClosePopover: EventName<IxMenuAboutNewsCustomEvent<void>>
};

export const IxMenuAboutNews: StencilReactComponent<IxMenuAboutNewsElement, IxMenuAboutNewsEvents> = /*@__PURE__*/ createComponent<IxMenuAboutNewsElement, IxMenuAboutNewsEvents>({
    tagName: 'ix-menu-about-news',
    properties: {
        show: 'show',
        label: 'label',
        i18nShowMore: 'i18n-show-more',
        aboutItemLabel: 'about-item-label',
        expanded: 'expanded'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuAboutNews as ReactWebComponent<IxMenuAboutNewsElement, IxMenuAboutNewsEvents>,
    serializeShadowRoot
});

export type IxMenuAvatarEvents = { onLogoutClick: EventName<IxMenuAvatarCustomEvent<any>> };

export const IxMenuAvatar: StencilReactComponent<IxMenuAvatarElement, IxMenuAvatarEvents> = /*@__PURE__*/ createComponent<IxMenuAvatarElement, IxMenuAvatarEvents>({
    tagName: 'ix-menu-avatar',
    properties: {
        top: 'top',
        bottom: 'bottom',
        image: 'image',
        initials: 'initials',
        tooltipText: 'tooltip-text',
        ariaLabelTooltip: 'aria-label-tooltip',
        i18nLogout: 'i18n-logout',
        hideLogoutButton: 'hide-logout-button',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuAvatar as ReactWebComponent<IxMenuAvatarElement, IxMenuAvatarEvents>,
    serializeShadowRoot
});

export type IxMenuAvatarItemEvents = { onItemClick: EventName<IxMenuAvatarItemCustomEvent<MouseEvent>> };

export const IxMenuAvatarItem: StencilReactComponent<IxMenuAvatarItemElement, IxMenuAvatarItemEvents> = /*@__PURE__*/ createComponent<IxMenuAvatarItemElement, IxMenuAvatarItemEvents>({
    tagName: 'ix-menu-avatar-item',
    properties: {
        icon: 'icon',
        label: 'label'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuAvatarItem as ReactWebComponent<IxMenuAvatarItemElement, IxMenuAvatarItemEvents>,
    serializeShadowRoot
});

export type IxMenuCategoryEvents = NonNullable<unknown>;

export const IxMenuCategory: StencilReactComponent<IxMenuCategoryElement, IxMenuCategoryEvents> = /*@__PURE__*/ createComponent<IxMenuCategoryElement, IxMenuCategoryEvents>({
    tagName: 'ix-menu-category',
    properties: {
        label: 'label',
        icon: 'icon',
        notifications: 'notifications',
        tooltipText: 'tooltip-text'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuCategory as ReactWebComponent<IxMenuCategoryElement, IxMenuCategoryEvents>,
    serializeShadowRoot
});

export type IxMenuItemEvents = NonNullable<unknown>;

export const IxMenuItem: StencilReactComponent<IxMenuItemElement, IxMenuItemEvents> = /*@__PURE__*/ createComponent<IxMenuItemElement, IxMenuItemEvents>({
    tagName: 'ix-menu-item',
    properties: {
        label: 'label',
        home: 'home',
        bottom: 'bottom',
        icon: 'icon',
        notifications: 'notifications',
        active: 'active',
        disabled: 'disabled',
        tooltipText: 'tooltip-text',
        href: 'href',
        target: 'target',
        rel: 'rel',
        isCategory: 'is-category'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuItem as ReactWebComponent<IxMenuItemElement, IxMenuItemEvents>,
    serializeShadowRoot
});

export type IxMenuSettingsEvents = {
    onTabChange: EventName<IxMenuSettingsCustomEvent<string>>,
    onClose: EventName<IxMenuSettingsCustomEvent<CustomCloseEvent>>
};

export const IxMenuSettings: StencilReactComponent<IxMenuSettingsElement, IxMenuSettingsEvents> = /*@__PURE__*/ createComponent<IxMenuSettingsElement, IxMenuSettingsEvents>({
    tagName: 'ix-menu-settings',
    properties: {
        activeTabLabel: 'active-tab-label',
        label: 'label',
        ariaLabelCloseButton: 'aria-label-close-button',
        show: 'show'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuSettings as ReactWebComponent<IxMenuSettingsElement, IxMenuSettingsEvents>,
    serializeShadowRoot
});

export type IxMenuSettingsItemEvents = { onLabelChange: EventName<IxMenuSettingsItemCustomEvent<CustomLabelChangeEvent>> };

export const IxMenuSettingsItem: StencilReactComponent<IxMenuSettingsItemElement, IxMenuSettingsItemEvents> = /*@__PURE__*/ createComponent<IxMenuSettingsItemElement, IxMenuSettingsItemEvents>({
    tagName: 'ix-menu-settings-item',
    properties: { label: 'label' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMenuSettingsItem as ReactWebComponent<IxMenuSettingsItemElement, IxMenuSettingsItemEvents>,
    serializeShadowRoot
});

export type IxMessageBarEvents = {
    onClosedChange: EventName<IxMessageBarCustomEvent<any>>,
    onCloseAnimationCompleted: EventName<IxMessageBarCustomEvent<any>>
};

export const IxMessageBar: StencilReactComponent<IxMessageBarElement, IxMessageBarEvents> = /*@__PURE__*/ createComponent<IxMessageBarElement, IxMessageBarEvents>({
    tagName: 'ix-message-bar',
    properties: {
        type: 'type',
        persistent: 'persistent'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxMessageBar as ReactWebComponent<IxMessageBarElement, IxMessageBarEvents>,
    serializeShadowRoot
});

export type IxModalEvents = {
    onDialogClose: EventName<IxModalCustomEvent<any>>,
    onDialogDismiss: EventName<IxModalCustomEvent<any>>
};

export const IxModal: StencilReactComponent<IxModalElement, IxModalEvents> = /*@__PURE__*/ createComponent<IxModalElement, IxModalEvents>({
    tagName: 'ix-modal',
    properties: {
        size: 'size',
        disableAnimation: 'disable-animation',
        hideBackdrop: 'hide-backdrop',
        closeOnBackdropClick: 'close-on-backdrop-click',
        centered: 'centered',
        disableEscapeClose: 'disable-escape-close'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxModal as ReactWebComponent<IxModalElement, IxModalEvents>,
    serializeShadowRoot
});

export type IxModalContentEvents = NonNullable<unknown>;

export const IxModalContent: StencilReactComponent<IxModalContentElement, IxModalContentEvents> = /*@__PURE__*/ createComponent<IxModalContentElement, IxModalContentEvents>({
    tagName: 'ix-modal-content',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxModalContent as ReactWebComponent<IxModalContentElement, IxModalContentEvents>,
    serializeShadowRoot
});

export type IxModalFooterEvents = NonNullable<unknown>;

export const IxModalFooter: StencilReactComponent<IxModalFooterElement, IxModalFooterEvents> = /*@__PURE__*/ createComponent<IxModalFooterElement, IxModalFooterEvents>({
    tagName: 'ix-modal-footer',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxModalFooter as ReactWebComponent<IxModalFooterElement, IxModalFooterEvents>,
    serializeShadowRoot
});

export type IxModalHeaderEvents = { onCloseClick: EventName<IxModalHeaderCustomEvent<MouseEvent>> };

export const IxModalHeader: StencilReactComponent<IxModalHeaderElement, IxModalHeaderEvents> = /*@__PURE__*/ createComponent<IxModalHeaderElement, IxModalHeaderEvents>({
    tagName: 'ix-modal-header',
    properties: {
        hideClose: 'hide-close',
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        ariaLabelCloseIconButton: 'aria-label-close-icon-button',
        iconColor: 'icon-color'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxModalHeader as ReactWebComponent<IxModalHeaderElement, IxModalHeaderEvents>,
    serializeShadowRoot
});

export type IxNumberInputEvents = {
    onValueChange: EventName<IxNumberInputCustomEvent<number>>,
    onValidityStateChange: EventName<IxNumberInputCustomEvent<ValidityState>>,
    onIxBlur: EventName<IxNumberInputCustomEvent<void>>,
    onIxChange: EventName<IxNumberInputCustomEvent<number>>
};

export const IxNumberInput: StencilReactComponent<IxNumberInputElement, IxNumberInputEvents> = /*@__PURE__*/ createComponent<IxNumberInputElement, IxNumberInputEvents>({
    tagName: 'ix-number-input',
    properties: {
        name: 'name',
        placeholder: 'placeholder',
        value: 'value',
        required: 'required',
        disabled: 'disabled',
        readonly: 'readonly',
        helperText: 'helper-text',
        infoText: 'info-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        validText: 'valid-text',
        warningText: 'warning-text',
        label: 'label',
        invalidText: 'invalid-text',
        pattern: 'pattern',
        min: 'min',
        max: 'max',
        allowedCharactersPattern: 'allowed-characters-pattern',
        showStepperButtons: 'show-stepper-buttons',
        step: 'step',
        suppressSubmitOnEnter: 'suppress-submit-on-enter',
        textAlignment: 'text-alignment',
        allowEmptyValueChange: 'allow-empty-value-change'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxNumberInput as ReactWebComponent<IxNumberInputElement, IxNumberInputEvents>,
    serializeShadowRoot
});

export type IxPaginationEvents = {
    onPageSelected: EventName<IxPaginationCustomEvent<number>>,
    onItemCountChanged: EventName<IxPaginationCustomEvent<number>>
};

export const IxPagination: StencilReactComponent<IxPaginationElement, IxPaginationEvents> = /*@__PURE__*/ createComponent<IxPaginationElement, IxPaginationEvents>({
    tagName: 'ix-pagination',
    properties: {
        advanced: 'advanced',
        itemCount: 'item-count',
        hideItemCount: 'hide-item-count',
        count: 'count',
        selectedPage: 'selected-page',
        i18nPage: 'i18n-page',
        i18nOf: 'i18n-of',
        i18nItems: 'i18n-items',
        ariaLabelChevronLeftIconButton: 'aria-label-chevron-left-icon-button',
        ariaLabelChevronRightIconButton: 'aria-label-chevron-right-icon-button',
        ariaLabelPageSelection: 'aria-label-page-selection'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxPagination as ReactWebComponent<IxPaginationElement, IxPaginationEvents>,
    serializeShadowRoot
});

export type IxPaneEvents = {
    onExpandedChanged: EventName<IxPaneCustomEvent<ExpandedChangedEvent>>,
    onVariantChanged: EventName<IxPaneCustomEvent<VariantChangedEvent>>,
    onBorderlessChanged: EventName<IxPaneCustomEvent<BorderlessChangedEvent>>
};

export const IxPane: StencilReactComponent<IxPaneElement, IxPaneEvents> = /*@__PURE__*/ createComponent<IxPaneElement, IxPaneEvents>({
    tagName: 'ix-pane',
    properties: {
        heading: 'heading',
        variant: 'variant',
        hideOnCollapse: 'hide-on-collapse',
        size: 'size',
        borderless: 'borderless',
        expanded: 'expanded',
        composition: 'composition',
        icon: 'icon',
        closeOnClickOutside: 'close-on-click-outside',
        ariaLabelIcon: 'aria-label-icon',
        ariaLabelCollapseCloseButton: 'aria-label-collapse-close-button',
        ignoreLayoutSettings: 'ignore-layout-settings',
        isMobile: 'is-mobile'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxPane as ReactWebComponent<IxPaneElement, IxPaneEvents>,
    serializeShadowRoot
});

export type IxPaneLayoutEvents = NonNullable<unknown>;

export const IxPaneLayout: StencilReactComponent<IxPaneLayoutElement, IxPaneLayoutEvents> = /*@__PURE__*/ createComponent<IxPaneLayoutElement, IxPaneLayoutEvents>({
    tagName: 'ix-pane-layout',
    properties: {
        layout: 'layout',
        variant: 'variant',
        borderless: 'borderless'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxPaneLayout as ReactWebComponent<IxPaneLayoutElement, IxPaneLayoutEvents>,
    serializeShadowRoot
});

export type IxPillEvents = NonNullable<unknown>;

export const IxPill: StencilReactComponent<IxPillElement, IxPillEvents> = /*@__PURE__*/ createComponent<IxPillElement, IxPillEvents>({
    tagName: 'ix-pill',
    properties: {
        variant: 'variant',
        outline: 'outline',
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        background: 'background',
        pillColor: 'pill-color',
        alignLeft: 'align-left',
        tooltipText: 'tooltip-text'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxPill as ReactWebComponent<IxPillElement, IxPillEvents>,
    serializeShadowRoot
});

export type IxProgressIndicatorEvents = NonNullable<unknown>;

export const IxProgressIndicator: StencilReactComponent<IxProgressIndicatorElement, IxProgressIndicatorEvents> = /*@__PURE__*/ createComponent<IxProgressIndicatorElement, IxProgressIndicatorEvents>({
    tagName: 'ix-progress-indicator',
    properties: {
        type: 'type',
        size: 'size',
        value: 'value',
        min: 'min',
        max: 'max',
        status: 'status',
        label: 'label',
        helperText: 'helper-text',
        textAlignment: 'text-alignment',
        showTextAsTooltip: 'show-text-as-tooltip'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxProgressIndicator as ReactWebComponent<IxProgressIndicatorElement, IxProgressIndicatorEvents>,
    serializeShadowRoot
});

export type IxPushCardEvents = NonNullable<unknown>;

export const IxPushCard: StencilReactComponent<IxPushCardElement, IxPushCardEvents> = /*@__PURE__*/ createComponent<IxPushCardElement, IxPushCardEvents>({
    tagName: 'ix-push-card',
    properties: {
        icon: 'icon',
        ariaLabelIcon: 'aria-label-icon',
        notification: 'notification',
        heading: 'heading',
        subheading: 'subheading',
        variant: 'variant',
        expanded: 'expanded',
        passive: 'passive'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxPushCard as ReactWebComponent<IxPushCardElement, IxPushCardEvents>,
    serializeShadowRoot
});

export type IxRadioEvents = {
    onCheckedChange: EventName<IxRadioCustomEvent<boolean>>,
    onValueChange: EventName<IxRadioCustomEvent<string>>,
    onIxBlur: EventName<IxRadioCustomEvent<void>>
};

export const IxRadio: StencilReactComponent<IxRadioElement, IxRadioEvents> = /*@__PURE__*/ createComponent<IxRadioElement, IxRadioEvents>({
    tagName: 'ix-radio',
    properties: {
        name: 'name',
        value: 'value',
        label: 'label',
        disabled: 'disabled',
        checked: 'checked',
        required: 'required'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxRadio as ReactWebComponent<IxRadioElement, IxRadioEvents>,
    serializeShadowRoot
});

export type IxRadioGroupEvents = { onValueChange: EventName<IxRadioGroupCustomEvent<string>> };

export const IxRadioGroup: StencilReactComponent<IxRadioGroupElement, IxRadioGroupEvents> = /*@__PURE__*/ createComponent<IxRadioGroupElement, IxRadioGroupEvents>({
    tagName: 'ix-radio-group',
    properties: {
        helperText: 'helper-text',
        label: 'label',
        value: 'value',
        invalidText: 'invalid-text',
        infoText: 'info-text',
        warningText: 'warning-text',
        validText: 'valid-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        direction: 'direction',
        required: 'required'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxRadioGroup as ReactWebComponent<IxRadioGroupElement, IxRadioGroupEvents>,
    serializeShadowRoot
});

export type IxRowEvents = NonNullable<unknown>;

export const IxRow: StencilReactComponent<IxRowElement, IxRowEvents> = /*@__PURE__*/ createComponent<IxRowElement, IxRowEvents>({
    tagName: 'ix-row',
    properties: {},
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxRow as ReactWebComponent<IxRowElement, IxRowEvents>,
    serializeShadowRoot
});

export type IxSelectEvents = {
    onValueChange: EventName<IxSelectCustomEvent<string | string[]>>,
    onInputChange: EventName<IxSelectCustomEvent<string>>,
    onAddItem: EventName<IxSelectCustomEvent<string>>,
    onIxBlur: EventName<IxSelectCustomEvent<void>>
};

export const IxSelect: StencilReactComponent<IxSelectElement, IxSelectEvents> = /*@__PURE__*/ createComponent<IxSelectElement, IxSelectEvents>({
    tagName: 'ix-select',
    properties: {
        name: 'name',
        required: 'required',
        label: 'label',
        ariaLabelChevronDownIconButton: 'aria-label-chevron-down-icon-button',
        ariaLabelClearIconButton: 'aria-label-clear-icon-button',
        warningText: 'warning-text',
        infoText: 'info-text',
        invalidText: 'invalid-text',
        validText: 'valid-text',
        helperText: 'helper-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        value: 'value',
        allowClear: 'allow-clear',
        mode: 'mode',
        editable: 'editable',
        disabled: 'disabled',
        readonly: 'readonly',
        i18nPlaceholder: 'i18n-placeholder',
        i18nPlaceholderEditable: 'i18n-placeholder-editable',
        i18nSelectListHeader: 'i18n-select-list-header',
        i18nNoMatches: 'i18n-no-matches',
        i18nAllSelected: 'i18n-all-selected',
        hideListHeader: 'hide-list-header',
        dropdownWidth: 'dropdown-width',
        dropdownMaxWidth: 'dropdown-max-width',
        collapseMultipleSelection: 'collapse-multiple-selection',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxSelect as ReactWebComponent<IxSelectElement, IxSelectEvents>,
    serializeShadowRoot
});

export type IxSelectItemEvents = { onItemClick: EventName<IxSelectItemCustomEvent<string>> };

export const IxSelectItem: StencilReactComponent<IxSelectItemElement, IxSelectItemEvents> = /*@__PURE__*/ createComponent<IxSelectItemElement, IxSelectItemEvents>({
    tagName: 'ix-select-item',
    properties: {
        label: 'label',
        value: 'value',
        selected: 'selected',
        hover: 'hover'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxSelectItem as ReactWebComponent<IxSelectItemElement, IxSelectItemEvents>,
    serializeShadowRoot
});

export type IxSliderEvents = { onValueChange: EventName<IxSliderCustomEvent<number>> };

export const IxSlider: StencilReactComponent<IxSliderElement, IxSliderEvents> = /*@__PURE__*/ createComponent<IxSliderElement, IxSliderEvents>({
    tagName: 'ix-slider',
    properties: {
        helperText: 'helper-text',
        label: 'label',
        invalidText: 'invalid-text',
        infoText: 'info-text',
        warningText: 'warning-text',
        validText: 'valid-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        step: 'step',
        min: 'min',
        max: 'max',
        value: 'value',
        trace: 'trace',
        traceReference: 'trace-reference',
        disabled: 'disabled',
        error: 'error'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxSlider as ReactWebComponent<IxSliderElement, IxSliderEvents>,
    serializeShadowRoot
});

export type IxSpinnerEvents = NonNullable<unknown>;

export const IxSpinner: StencilReactComponent<IxSpinnerElement, IxSpinnerEvents> = /*@__PURE__*/ createComponent<IxSpinnerElement, IxSpinnerEvents>({
    tagName: 'ix-spinner',
    properties: {
        variant: 'variant',
        size: 'size',
        hideTrack: 'hide-track'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxSpinner as ReactWebComponent<IxSpinnerElement, IxSpinnerEvents>,
    serializeShadowRoot
});

export type IxSplitButtonEvents = { onButtonClick: EventName<IxSplitButtonCustomEvent<MouseEvent>> };

export const IxSplitButton: StencilReactComponent<IxSplitButtonElement, IxSplitButtonEvents> = /*@__PURE__*/ createComponent<IxSplitButtonElement, IxSplitButtonEvents>({
    tagName: 'ix-split-button',
    properties: {
        variant: 'variant',
        closeBehavior: 'close-behavior',
        label: 'label',
        ariaLabelButton: 'aria-label-button',
        icon: 'icon',
        splitIcon: 'split-icon',
        ariaLabelSplitIconButton: 'aria-label-split-icon-button',
        disabled: 'disabled',
        disableButton: 'disable-button',
        disableDropdownButton: 'disable-dropdown-button',
        placement: 'placement',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxSplitButton as ReactWebComponent<IxSplitButtonElement, IxSplitButtonEvents>,
    serializeShadowRoot
});

export type IxTabItemEvents = { onTabClick: EventName<IxTabItemCustomEvent<TabClickDetail>> };

export const IxTabItem: StencilReactComponent<IxTabItemElement, IxTabItemEvents> = /*@__PURE__*/ createComponent<IxTabItemElement, IxTabItemEvents>({
    tagName: 'ix-tab-item',
    properties: {
        selected: 'selected',
        disabled: 'disabled',
        small: 'small',
        icon: 'icon',
        rounded: 'rounded',
        counter: 'counter',
        layout: 'layout',
        placement: 'placement'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTabItem as ReactWebComponent<IxTabItemElement, IxTabItemEvents>,
    serializeShadowRoot
});

export type IxTabsEvents = { onSelectedChange: EventName<IxTabsCustomEvent<number>> };

export const IxTabs: StencilReactComponent<IxTabsElement, IxTabsEvents> = /*@__PURE__*/ createComponent<IxTabsElement, IxTabsEvents>({
    tagName: 'ix-tabs',
    properties: {
        small: 'small',
        rounded: 'rounded',
        selected: 'selected',
        layout: 'layout',
        placement: 'placement',
        ariaLabelChevronLeftIconButton: 'aria-label-chevron-left-icon-button',
        ariaLabelChevronRightIconButton: 'aria-label-chevron-right-icon-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTabs as ReactWebComponent<IxTabsElement, IxTabsEvents>,
    serializeShadowRoot
});

export type IxTextareaEvents = {
    onValueChange: EventName<IxTextareaCustomEvent<string>>,
    onValidityStateChange: EventName<IxTextareaCustomEvent<ValidityState>>,
    onIxBlur: EventName<IxTextareaCustomEvent<void>>,
    onIxChange: EventName<IxTextareaCustomEvent<string>>
};

export const IxTextarea: StencilReactComponent<IxTextareaElement, IxTextareaEvents> = /*@__PURE__*/ createComponent<IxTextareaElement, IxTextareaEvents>({
    tagName: 'ix-textarea',
    properties: {
        name: 'name',
        placeholder: 'placeholder',
        value: 'value',
        required: 'required',
        disabled: 'disabled',
        readonly: 'readonly',
        helperText: 'helper-text',
        infoText: 'info-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        validText: 'valid-text',
        warningText: 'warning-text',
        label: 'label',
        invalidText: 'invalid-text',
        textareaHeight: 'textarea-height',
        textareaWidth: 'textarea-width',
        textareaRows: 'textarea-rows',
        textareaCols: 'textarea-cols',
        resizeBehavior: 'resize-behavior',
        maxLength: 'max-length',
        minLength: 'min-length'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTextarea as ReactWebComponent<IxTextareaElement, IxTextareaEvents>,
    serializeShadowRoot
});

export type IxTileEvents = NonNullable<unknown>;

export const IxTile: StencilReactComponent<IxTileElement, IxTileEvents> = /*@__PURE__*/ createComponent<IxTileElement, IxTileEvents>({
    tagName: 'ix-tile',
    properties: { size: 'size' },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTile as ReactWebComponent<IxTileElement, IxTileEvents>,
    serializeShadowRoot
});

export type IxTimeInputEvents = {
    onValueChange: EventName<IxTimeInputCustomEvent<string>>,
    onValidityStateChange: EventName<IxTimeInputCustomEvent<TimeInputValidityState>>,
    onIxChange: EventName<IxTimeInputCustomEvent<string>>
};

export const IxTimeInput: StencilReactComponent<IxTimeInputElement, IxTimeInputEvents> = /*@__PURE__*/ createComponent<IxTimeInputElement, IxTimeInputEvents>({
    tagName: 'ix-time-input',
    properties: {
        name: 'name',
        placeholder: 'placeholder',
        value: 'value',
        format: 'format',
        required: 'required',
        helperText: 'helper-text',
        label: 'label',
        invalidText: 'invalid-text',
        readonly: 'readonly',
        disabled: 'disabled',
        infoText: 'info-text',
        warningText: 'warning-text',
        validText: 'valid-text',
        showTextAsTooltip: 'show-text-as-tooltip',
        i18nErrorTimeUnparsable: 'i18n-error-time-unparsable',
        hourInterval: 'hour-interval',
        minuteInterval: 'minute-interval',
        secondInterval: 'second-interval',
        millisecondInterval: 'millisecond-interval',
        i18nSelectTime: 'i18n-select-time',
        i18nTime: 'i18n-time',
        i18nHourColumnHeader: 'i18n-hour-column-header',
        i18nMinuteColumnHeader: 'i18n-minute-column-header',
        i18nSecondColumnHeader: 'i18n-second-column-header',
        i18nMillisecondColumnHeader: 'i18n-millisecond-column-header',
        suppressSubmitOnEnter: 'suppress-submit-on-enter',
        hideHeader: 'hide-header',
        textAlignment: 'text-alignment',
        enableTopLayer: 'enable-top-layer'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTimeInput as ReactWebComponent<IxTimeInputElement, IxTimeInputEvents>,
    serializeShadowRoot
});

export type IxTimePickerEvents = {
    onTimeSelect: EventName<IxTimePickerCustomEvent<string>>,
    onTimeChange: EventName<IxTimePickerCustomEvent<string>>
};

export const IxTimePicker: StencilReactComponent<IxTimePickerElement, IxTimePickerEvents> = /*@__PURE__*/ createComponent<IxTimePickerElement, IxTimePickerEvents>({
    tagName: 'ix-time-picker',
    properties: {
        format: 'format',
        corners: 'corners',
        embedded: 'embedded',
        dateTimePickerAppearance: 'date-time-picker-appearance',
        hideHeader: 'hide-header',
        hourInterval: 'hour-interval',
        minuteInterval: 'minute-interval',
        secondInterval: 'second-interval',
        millisecondInterval: 'millisecond-interval',
        time: 'time',
        i18nConfirmTime: 'i18n-confirm-time',
        i18nHeader: 'i18n-header',
        i18nHourColumnHeader: 'i18n-column-header',
        i18nMinuteColumnHeader: 'i18n-minute-column-header',
        i18nSecondColumnHeader: 'i18n-second-column-header',
        i18nMillisecondColumnHeader: 'i18n-millisecond-column-header'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTimePicker as ReactWebComponent<IxTimePickerElement, IxTimePickerEvents>,
    serializeShadowRoot
});

export type IxToastEvents = { onCloseToast: EventName<IxToastCustomEvent<any>> };

export const IxToast: StencilReactComponent<IxToastElement, IxToastEvents> = /*@__PURE__*/ createComponent<IxToastElement, IxToastEvents>({
    tagName: 'ix-toast',
    properties: {
        type: 'type',
        toastTitle: 'toast-title',
        autoCloseDelay: 'auto-close-delay',
        preventAutoClose: 'prevent-auto-close',
        icon: 'icon',
        iconColor: 'icon-color',
        hideIcon: 'hide-icon',
        ariaLabelCloseIconButton: 'aria-label-close-icon-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxToast as ReactWebComponent<IxToastElement, IxToastEvents>,
    serializeShadowRoot
});

export type IxToastContainerEvents = NonNullable<unknown>;

export const IxToastContainer: StencilReactComponent<IxToastContainerElement, IxToastContainerEvents> = /*@__PURE__*/ createComponent<IxToastContainerElement, IxToastContainerEvents>({
    tagName: 'ix-toast-container',
    properties: {
        containerId: 'container-id',
        containerClass: 'container-class',
        position: 'position'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxToastContainer as ReactWebComponent<IxToastContainerElement, IxToastContainerEvents>,
    serializeShadowRoot
});

export type IxToggleEvents = {
    onCheckedChange: EventName<IxToggleCustomEvent<boolean>>,
    onIxBlur: EventName<IxToggleCustomEvent<void>>
};

export const IxToggle: StencilReactComponent<IxToggleElement, IxToggleEvents> = /*@__PURE__*/ createComponent<IxToggleElement, IxToggleEvents>({
    tagName: 'ix-toggle',
    properties: {
        name: 'name',
        value: 'value',
        checked: 'checked',
        disabled: 'disabled',
        indeterminate: 'indeterminate',
        textOn: 'text-on',
        textOff: 'text-off',
        textIndeterminate: 'text-indeterminate',
        hideText: 'hide-text',
        required: 'required'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxToggle as ReactWebComponent<IxToggleElement, IxToggleEvents>,
    serializeShadowRoot
});

export type IxToggleButtonEvents = { onPressedChange: EventName<IxToggleButtonCustomEvent<boolean>> };

export const IxToggleButton: StencilReactComponent<IxToggleButtonElement, IxToggleButtonEvents> = /*@__PURE__*/ createComponent<IxToggleButtonElement, IxToggleButtonEvents>({
    tagName: 'ix-toggle-button',
    properties: {
        variant: 'variant',
        disabled: 'disabled',
        loading: 'loading',
        icon: 'icon',
        iconRight: 'icon-right',
        pressed: 'pressed',
        ariaLabelButton: 'aria-label-button'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxToggleButton as ReactWebComponent<IxToggleButtonElement, IxToggleButtonEvents>,
    serializeShadowRoot
});

export type IxTooltipEvents = NonNullable<unknown>;

export const IxTooltip: StencilReactComponent<IxTooltipElement, IxTooltipEvents> = /*@__PURE__*/ createComponent<IxTooltipElement, IxTooltipEvents>({
    tagName: 'ix-tooltip',
    properties: {
        for: 'for',
        titleContent: 'title-content',
        interactive: 'interactive',
        placement: 'placement',
        showDelay: 'show-delay',
        hideDelay: 'hide-delay',
        animationFrame: 'animation-frame'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTooltip as ReactWebComponent<IxTooltipElement, IxTooltipEvents>,
    serializeShadowRoot
});

export type IxTypographyEvents = NonNullable<unknown>;

export const IxTypography: StencilReactComponent<IxTypographyElement, IxTypographyEvents> = /*@__PURE__*/ createComponent<IxTypographyElement, IxTypographyEvents>({
    tagName: 'ix-typography',
    properties: {
        format: 'format',
        textColor: 'text-color',
        bold: 'bold',
        textDecoration: 'text-decoration'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxTypography as ReactWebComponent<IxTypographyElement, IxTypographyEvents>,
    serializeShadowRoot
});

export type IxUploadEvents = { onFilesChanged: EventName<IxUploadCustomEvent<Array<File>>> };

export const IxUpload: StencilReactComponent<IxUploadElement, IxUploadEvents> = /*@__PURE__*/ createComponent<IxUploadElement, IxUploadEvents>({
    tagName: 'ix-upload',
    properties: {
        accept: 'accept',
        multiple: 'multiple',
        multiline: 'multiline',
        disabled: 'disabled',
        state: 'state',
        selectFileText: 'select-file-text',
        loadingText: 'loading-text',
        uploadFailedText: 'upload-failed-text',
        uploadSuccessText: 'upload-success-text',
        i18nUploadFile: 'i18n-upload-file',
        i18nUploadDisabled: 'i18n-upload-disabled'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxUpload as ReactWebComponent<IxUploadElement, IxUploadEvents>,
    serializeShadowRoot
});

export type IxValidationTooltipEvents = NonNullable<unknown>;

export const IxValidationTooltip: StencilReactComponent<IxValidationTooltipElement, IxValidationTooltipEvents> = /*@__PURE__*/ createComponent<IxValidationTooltipElement, IxValidationTooltipEvents>({
    tagName: 'ix-validation-tooltip',
    properties: {
        message: 'message',
        placement: 'placement',
        suppressAutomaticPlacement: 'suppress-automatic-placement'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxValidationTooltip as ReactWebComponent<IxValidationTooltipElement, IxValidationTooltipEvents>,
    serializeShadowRoot
});

export type IxWorkflowStepEvents = NonNullable<unknown>;

export const IxWorkflowStep: StencilReactComponent<IxWorkflowStepElement, IxWorkflowStepEvents> = /*@__PURE__*/ createComponent<IxWorkflowStepElement, IxWorkflowStepEvents>({
    tagName: 'ix-workflow-step',
    properties: {
        vertical: 'vertical',
        disabled: 'disabled',
        status: 'status',
        clickable: 'clickable',
        selected: 'selected',
        position: 'position'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxWorkflowStep as ReactWebComponent<IxWorkflowStepElement, IxWorkflowStepEvents>,
    serializeShadowRoot
});

export type IxWorkflowStepsEvents = { onStepSelected: EventName<IxWorkflowStepsCustomEvent<number>> };

export const IxWorkflowSteps: StencilReactComponent<IxWorkflowStepsElement, IxWorkflowStepsEvents> = /*@__PURE__*/ createComponent<IxWorkflowStepsElement, IxWorkflowStepsEvents>({
    tagName: 'ix-workflow-steps',
    properties: {
        vertical: 'vertical',
        clickable: 'clickable',
        selectedIndex: 'selected-index'
    },
    hydrateModule: import('@siemens/ix/hydrate') as Promise<HydrateModule>,
    clientModule: clientComponents.IxWorkflowSteps as ReactWebComponent<IxWorkflowStepsElement, IxWorkflowStepsEvents>,
    serializeShadowRoot
});
